// @flow
import moment from 'moment';
import { ListItem } from 'material-ui/List';
import React from 'react';
import { withTheme } from 'styled-components';
import HistoryListWeek from './HistoryListWeek';
import type { MonthData } from '../domain/History';

const monthStyle = theme => ({ fontSize: 16, backgroundColor: theme.colors.primaryBackground });
const listGroupStyle = { padding: '0' };

type Props = {
  month: MonthData,
  open: boolean,
  onClick: (key: string) => void,
  selectedDate: moment,

  theme: any,
}

function HistoryListMonth(props: Props) {
  const { month, open, onClick, selectedDate } = props;

  return (
    <ListItem
      primaryText={month.month}
      open={open}
      primaryTogglesNestedList
      onNestedListToggle={() => onClick(month.month)}
      nestedListStyle={listGroupStyle}
      nestedItems={month.weeks.map(w => <HistoryListWeek key={w.from.toISOString()} week={w} selectedDate={selectedDate} />)}
      style={monthStyle(props.theme)}
    />
  );
}

export default withTheme(HistoryListMonth);



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/components/HistoryListMonth.js